import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Padampurafront from '../images/Padampurafront.jpg';
import PadampuraTemple from '../images/PadampuraTemple.jpg';
import { FaLocationDot, FaMapPin } from 'react-icons/fa6';
import { MdCall, MdOutlineAddIcCall } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import Hall from '../images/Hall.jpg'
import DeluxRoom from '../images/DeluxRoom.jfif'
import Availableroom from './Availableroom';

export default function Dharmshala() {
  const lottiee = require('../images/lottiee.json');
  const loading = require('../images/loading.json');

  const navigate = useNavigate();

  const [dharmshala, setDharamshala] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchDharmshala();
    scrollToTop();
  }, []);

  const fetchDharmshala = () => {
    setLoader(true);
    fetch("https://api.padampura.com/All_Dharmshalas", { method: "GET", redirect: "follow" })
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          setDharamshala(result.data);
        }
      })
      .catch((error) => console.error("API Error:", error))
      .finally(() => setLoader(false));
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  console.log(dharmshala)
  return (
    <div>

      <Helmet>
        <title>Dharmshala Listings | Padampura Jain Tirth</title>
        <meta name="description" content="Explore a list of well-maintained Jain Dharmshalas at Padampura Tirth with contact details, booking information, and images. Book your stay today." />
        <meta name="keywords" content="Jain Dharmshala, Padampura Tirth, Jain Accommodation, Book Dharmshala, Padampura Stay" />
        <link rel="canonical" href="https://padampura.com/Dharmshala" />
      </Helmet>
      {/* Header Image */}
      <div className='mt-3'>
        <div className='dhrm-back'>
          <img
            src={Padampurafront}
            alt="Padampura Front"
            style={{ width: "100%", height: "80vh", objectFit: "cover" }}
          />
        </div>
      </div>

      {/* Main Section */}
      <div className='container my-5'>
        <p className='text-center' style={{ fontFamily: 'Poppins', fontSize: "1.5em", fontWeight: 500 }}>
          JAIN'S DHARAMSHALA
        </p>

        {/* Loading Animation */}
        {loader ? (
          <div className='text-center'>
            <div style={{ fontFamily: "Poppins", fontSize: 16 }}>Loading...</div>
            <Player autoplay loop src={loading} style={{ height: '200px', width: '200px' }}>
              <Controls visible={false} buttons={['play', 'repeat']} />
            </Player>
          </div>
        ) : dharmshala.length === 0 ? (
          // Empty state
          <div className='text-center'>
            <Player autoplay loop src={lottiee} style={{ height: '180px', width: '180px' }}>
              <Controls visible={false} buttons={['play', 'repeat']} />
            </Player>
            <div style={{ fontFamily: "Poppins", fontSize: 16, color: 'red' }}>Data Not Present...</div>
          </div>
        ) : (
          // Dharmshala Cards
          <div className='container'>
            <div className='row'>
              {dharmshala.map((dharam) => {
                return <div key={dharam.dhrm_id} className='rounded col-12 col-md-4 p-2'>
                  <div
                    className="card shadow p-2 h-100 border-0 dharam-card"
                    role="button"
                    onClick={() => navigate(`/DharmshalaDetail/${dharam.dhrm_id}`)}
                  >
                    {/* Image */}
                    <img
                      src="https://d3sftlgbtusmnv.cloudfront.net/blog/wp-content/uploads/2024/10/Jain-temple-Cover-Photo--840x425.jpg"
                      className="card-img-top img-fluid rounded"
                      alt={dharam.dhrm_name}
                    />

                    {/* Body */}
                    <div className="card-body p-3">
                      <h6 className="card-title fw-bold mb-1 text-truncate">
                        {dharam.dhrm_name}
                      </h6>

                      <p className="text-muted small mb-2 d-flex align-items-center gap-1">
                        <FaMapPin color="red" />
                        <span className="text-truncate">{dharam.dhrm_location}</span>
                      </p>

                      {/* Rooms */}
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <span className="fw-semibold text-muted small">Rooms</span>
                        <div className="text-end small">
                          <div>AC</div>
                          <div>Non-AC</div>
                        </div>
                      </div>

                      <hr className="my-2" />

                      {/* Contact */}
                      <div className="d-flex flex-column gap-1">
                        <a
                          href={`tel:+91${dharam.dhrm_mob}`}
                          className="text-decoration-none text-dark small d-flex align-items-center gap-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <MdOutlineAddIcCall size={18} />
                          {dharam.dhrm_mob}
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              })}
            </div>
          </div>

        )}
      </div>


      {/* Scroll to Top */}
      <button
        className="scroll-to-top-button border-0 rounded-2"
        onClick={scrollToTop}
        style={{
          width: 40,
          height: 40,
          backgroundColor: "red",
          color: "#fff",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          position: "fixed",
          bottom: "30px",
          right: "30px",
          zIndex: 999,
        }}
      >
        <IoArrowUpCircleOutline style={{ fontSize: 40 }} />
      </button>

      {/* <Availableroom/> */}

      {/* <div className='container px-5'>
        <h1 className='text-center text-danger mb-5'>Booking Facilities</h1>

        <div className='d-flex justify-content-between flex-wrap gap'>
          <div onClick={() => navigate('/Dharmshala/bookingFacilities', { state: 'Hall' })} style={{ width: '400px' }} className='cursor-pointer mx-3 p-5 shadow d-flex flex-column rounded-3 gap-3'>
            <img className='rounded-3' style={{ width: '100%' }} src={Hall} />
            <p className='text-blue text-center h4'>Banquet Hall</p>
          </div>
          <div onClick={() => navigate('/Dharmshala/bookingFacilities', { state: 'Rooms' })} style={{ width: '400px' }} className='mx-3 p-5 shadow d-flex flex-column rounded-3 gap-3'>
            <img className='rounded-3' style={{ width: '90%' }} src={DeluxRoom} />
            <p className='text-blue text-center h4'>Room</p>
          </div>
        </div>
      </div> */}

    </div >
  );
}
